import { Navigate } from 'react-router-dom';
import { usePermissions } from '../../contexts/PermissionContext';
import type { UserRole } from '../../types/permissions';

interface RoleBasedRouteProps {
  children: React.ReactNode;
  allowedRoles: UserRole[];
}

/**
 * Route guard: redireciona para /main se role não permitido
 */
export function RoleBasedRoute({ children, allowedRoles }: RoleBasedRouteProps) {
  const { role } = usePermissions();

  if (!allowedRoles.includes(role)) {
    console.warn(`[RoleBasedRoute] Role '${role}' não permitido - redirecionando para /main`);
    return <Navigate to="/main" replace />;
  }

  return <>{children}</>;
}
